<template functional>
  <button
    class="inline-flex items-center block px-6 py-3 text-blue-600 transition-colors duration-100 ease-out bg-gray-100 border border-blue-300 rounded shadow focus:outline-none focus:shadow-outline hover:bg-blue-500 hover:text-white"
    :class="$options.methods.mergeFunctionalRenderContextClasses(data)"
    v-bind="{
      type: 'button',
      ...data.attrs,
    }"
    v-on="listeners"
  >
    <slot />
  </button>
</template>

<script>
import { mergeFunctionalRenderContextClasses } from '@/helpers/utils'

export default {
  name: 'MiaCarEditPageHeaderActionButton',

  methods: {
    mergeFunctionalRenderContextClasses
  }
}
</script>
